<template>
  <div>
    <div v-for="(section, key) in value" :key="section.id" class="mb-5">
      <div class="border-bottom pb-3">
        <div class="font-weight-bold d-flex align-items-center">
          <span
            class="title-number-box rounded text-white text-center mr-2 py-1"
          >
            {{ key + 1 }}
          </span>
          <span>
            {{ section.name | empty }}
          </span>
        </div>
      </div>
      <div
        v-for="(question, qKey) in section.questions"
        :key="question.id"
        class="border-bottom pb-3 my-3"
      >
        <expectative
          v-if="isExpectativeQuestion(question)"
          v-model="question.value"
          :data="question"
          :is-read-only="isReadOnly"
          :title="getExpectativeTitle(key, qKey)"
        />
        <div v-else>Tipo de pregunta no soportada actualmente</div>
      </div>
    </div>
  </div>
</template>

<script>
import Expectative from './questionTypes/Expectative.vue';
export default {
  name: 'RubricPreviewSections',
  components: {
    Expectative,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    ordered: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    isExpectativeQuestion() {
      return ({ typeId }) => typeId === 1; //Question supported to select expectative
    },
    getExpectativeTitle() {
      return (key, key2) => (this.ordered ? `${key + 1}.${key2 + 1}` : null);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/brand_variables.scss';
.title-number-box {
  background-color: #2db782;
  width: 30px;
}
</style>
